import { type BaseProductElementProps } from "~/domains/product/types/BaseProductElementProps";
import { useProductContext } from "~/domains/product/ProductContext";
import { Typography, type TypographyProps } from "~/common/mui";

type Props = BaseProductElementProps &
  Omit<TypographyProps, "children"> & {
    truncate?: boolean;
  };

export const DescriptionV2 = (props: Props) => {
  const product = useProductContext(props);

  return <Typography {...props}>{product.description}</Typography>;
};
